<template>
    <div>

        <nav class="level is-mobile">
            <div class="level-left">
                <div class="level-item">
 
                </div>

            </div>
            <div class="level-right">
                <!--                    has-background-danger-light-->
<!--                <div class="level-item">-->
<!--                    <figure class="image is-32x32" v-if="dataCytoSpecLN.dat_prepare.avartar">-->
<!--                        <img  class="is-rounded"  :src="dataAvartar(dataCytoSpecLN.dat_prepare.user_rec_id,dataCytoSpecLN.dat_prepare.avartar)" alt="Image">-->
<!--                    </figure>-->
<!--                </div>-->

                <div class="level-item">

                </div>
                <div class="level-item">
                    <p class="has-text-grey is-size-7">{{user_rec}}</p>
                </div>
                <div class="level-item">
                    <p  class="has-text-grey  is-size-7"> {{date_rec}}   {{time_rec}} </p>
                </div>
                <div class="level-item" v-if="user_delete !== '' ">
                    <p  class="has-text-danger  is-size-7"> ลบโดย <span class="has-text-danger" >{{user_delete}}  {{date_delete}}   {{time_delete}}</span>   </p>
                </div>
                <div class="level-item">


                    <b-button   type="is-danger is-light"
                                icon-right="delete"
                                v-if="userIsAdmin && canDelete"
                                @click="deleteThisID"/>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
    /* eslint-disable */
    import globalconst from "../../../mixins/globalconst";
    import axios from "axios";
    import { getBaseURLforBackEnd , getConfigAxios  } from '@/utils.js'
    import {mapState} from "vuex";



    export default {
        name: "FooterPlus",
        mixins:[globalconst],
        computed:{
            ...mapState({
                clientIP : state => state.master_data.clientIP,
                access_token: state => state.master_data.access_token,
            }),
        },
        props:{
            // for display
            user_rec : String,
            date_rec : String,
            time_rec : String,

            // for delete
            userIsAdmin : Boolean,
            idToDelete : String, // sometime string , sometime int
                                 // everything int except images(normal), diag_code(normal)
                                 // pass idlab for all disable
            typeToDelete : String ,
            labKind : String,
            canDelete : {
                type: Boolean,
                default: true
            },
            // for display
            user_delete :   {
                            type: String,
                            default: ''
                            },
            date_delete :   {
                            type: String,
                            default: ''
                            },
            time_delete :   {
                            type: String,
                            default: ''
                            },

        },
        methods:{

            deleteThisIDReal(){
                
                const datTo =  {
                    category  : this.typeToDelete ,
                    id : this.idToDelete ,
                    ip :  this.clientIP ,
                    id_disable_lab : null
                }


                var disableContentLab_ = ""
                if (this.labKind.toUpperCase() ===  "CYTOLOGY"){
                    disableContentLab_ = "disablecontentcytolab"
                }
                else if(this.labKind.toUpperCase() ===  "BIOPSY"){
                    disableContentLab_ = "disablecontentbiopsylab"
                }
                else if(this.labKind.toUpperCase() ===  "PCR"){
                    disableContentLab_ = "disablecontentpcrlab"
                }
                else if(this.labKind.toUpperCase() ===  "BACTERIAL"){
                    disableContentLab_ = "disablecontent_bacterial_lab"
                }
                else if(this.labKind.toUpperCase() ===  "NECROPSY"){
                    disableContentLab_ = "disablecontent_necropsy_lab"
                }
                else if(this.labKind.toUpperCase() ===  "PARASITE"){
                    disableContentLab_ = "disablecontent_parasite_lab"
                }
                else if(this.labKind.toUpperCase() ===  "ORGANISM"){
                    disableContentLab_ = "disablecontent_organism_lab"
                } 
                else {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: `Something Error Not Found variable labKind ` ,
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                    return
                }

                // console.log(disableContentLab_)
                console.log(JSON.stringify(datTo))


                const vm = this
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}` 
                axios.post(`${getBaseURLforBackEnd()}/api/${disableContentLab_}`,datTo,getConfigAxios())
                    .then(()=>{
                        vm.$buefy.toast.open({
                            message: 'Update data completely!',
                            type: 'is-success'
                        })
                    })
                    .catch(err=>{

                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err.message}` ,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })

                        if (err.response && err.response.status === 401) {
                            vm.$router.push('/login')
                        }
                    })
                this.$emit("footerPlusWithChangeDisable")
            },



            deleteThisID(){
               
                this.$buefy.dialog.confirm({
                    title: 'Deleting content',
                    message: 'Are you sure you want to <b>cannot be restored</b> your content? This action cannot be undone.',
                    confirmText: 'Delete content',
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => this.deleteThisIDReal()
                })

            }
        }
    }
</script>

<style scoped>

</style>